module.exports = __webpack_public_path__ + "img/circuito.8bc45297.jpg";